import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkBlue({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkBlue}>{children}</span>;
}
